<template>
    <div class="theme_common_bg_section">
        <div class="common_page_header">
            <button type="button" tapable="" class="btn btn-white-transparent back_btn"><i aria-hidden="true"
                    class="fa fa-chevron-left"></i></button> Quizzes
        </div>
        <div class="common_page_body">
            <div class="row">
                <div class="col-sm-3">
                    <div class="cstm_card_box">
                        <router-link :to="{name:'pubQuizzesCat'}" class="cstm_card_link">
                            <span class="cstm_card_icon">
                                <i class="fa fa-podcast" aria-hidden="true"></i>
                            </span>
                            <span class="cstm_card_title">
                                Public Quiz
                            </span>
                        </router-link>
                    </div>
                </div>
                <div class="col-sm-3">
                    <div class="cstm_card_box">
                        <router-link :to="{name:'contestQuizzesCat'}" class="cstm_card_link">
                            <span class="cstm_card_icon">
                                <i class="fa fa-quora" aria-hidden="true"></i>
                            </span>
                            <span class="cstm_card_title">
                                Contest Quiz
                            </span>
                        </router-link>
                    </div>
                </div>
                <div class="col-sm-3">
                    <div class="cstm_card_box">
                        <router-link :to="{name:'interviewUnitList'}" class="cstm_card_link">
                            <span class="cstm_card_icon">
                                <i class="fa fa-modx" aria-hidden="true"></i>
                            </span>
                            <span class="cstm_card_title">
                                Interview Quiz
                            </span>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.theme_common_bg_section {
    background: rgba(0, 0, 0, 0.7);
    margin-bottom: 0;
    border-radius: 5px;
    min-height: calc(100vh - 96px);
    position: relative;
    overflow: hidden;

    .common_page_header {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -ms-flex-wrap: wrap;
        flex-wrap: wrap;
        border-bottom: solid 1px rgba(228, 233, 237, 0.1);
        position: relative;
        font-family: 'MyriadProSemibold', 'Lato', sans-serif;
        font-weight: normal;
        font-size: 22px;
        padding: 10px 15px;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
    }

    .common_page_body{
        padding:15px;
        .cstm_card_box {
                background: rgba(24, 24, 24, 0.7);
                transition: all ease 0.5s;
                -webkit-transition: all ease 0.5s;
                -moz-transition: all ease 0.5s;
                border: 1px solid #2c2b2b;
                border-radius: 5px;
                text-align: center;
                padding: 60px 35px;
                margin: 15px 0;
                cursor: pointer;

                &:hover {
                    background: #ffffff;
                    color: #000000;

                    .cstm_card_title {
                        color: #000000;
                    }
                    .fa{
                        color: #000000 !important;
                    }
                }

                span {
                    display: block;
                }
            .cstm_card_icon{
                .fa{
                    font-size: 48px;
                    color: #ffd700;
                }
            }
            .cstm_card_title {
                font-size: 22px;
                color: #fff;
                font-weight: 600;
                padding: 30px 0px 0px;
                font-family: 'Beon';
            }
            a{text-decoration: none;}
        }
    }
}
</style>